export enum GiftState {
	Running		= 1,
	Validating	= 2,
	Validated	= 3
}